import * as Common from '@/agiles/common';
import { ReportTemplate } from './reportTemplate';

export class ReportLayout extends Common.StateObject2 {
  constructor() {
    super('ReportLayout');
    this.binders.pageLayout1 = new Common.ModelBinder(PageLayout);
    this.binders.pageLayout2 = new Common.ModelBinder(PageLayout);
    this.binders.imageLayouts = new Common.ModelBinder(ImageLayout);
    this.binders.template = new Common.ModelBinder(ReportTemplate);
  }
  public id: number = 0;
  public template: ReportTemplate;
  public seq: number =0;
  public sheetName: string;
  public listPropertyName: string;
  public hiddenRuledLine :boolean = false;
  public suppressLayout  :boolean = false;
  public multiLayout:boolean = false;
  public grandTotal = false;
  public grouping1 :string;
  public grouping2 :string;
  public grouping3 :string;
  
  public get multiLayout2(): boolean{
    return this.multiLayout;
  }
  public set multiLayout2(value: boolean){
    this.multiLayout = value;
    if (value && this.pageLayout2 == null) this.pageLayout2 = new PageLayout();
    else if (value == false) this.pageLayout2 = null;
  }
  public pageLayout1: PageLayout = new PageLayout();
  public pageLayout2: PageLayout = null;
  public imageLayouts: ImageLayout[] = new Array();

  public get itemNames() {
    if (this.template && this.template.controller) return this.template.controller.itemNames;
    else return new Array();
  }
  public get groupingFields() {
    if (this.template && this.template.controller && this.listPropertyName) return this.template.controller.groupingFields[this.listPropertyName];
    else return new Array();
  }

  public copy():any {
    const temp = super.copy() as ReportLayout;
    temp.id = 0;
    if (temp.pageLayout1){
      temp.pageLayout1.id = 0;
    }
    if (temp.pageLayout2){
      temp.pageLayout2.id = 0;
    }    
    return temp;
  }    
  public get messageOnEdit():string { 
    return '帳票テンプレートで「公開取消」をクリックし、状態を「公開待ち」に戻してから編集してください。';  
  }  
  public get messageOnDelete():string {
    return '帳票テンプレートで「公開取消」をクリックし、状態を「公開待ち」に戻してから削除してください。';
  }
}

export class ReportLayoutQuery extends Common.LoadQuery {
  constructor() {
    super('ReportLayoutQuery', ReportLayout);
    this.sort = 'viewName';
    this.state = Common.ApprovalStatus.All;
  }
  public templateId: number =0;
  public id:number;
  public state: Common.ApprovalStatus;
}

export class ImageLayout extends Common.ObjectBase {
  constructor() {
    super('ImageLayout');
  }
  public id: number;
  public layoutId: number;
  public imageSource: ImageSourceFlags;
  public destinationPage: PageFlags;
  public positionX: number;
  public positionY: number;
}

export class PageLayout extends Common.ObjectBase {
  constructor() {
    super('PageLayout');
  }
  public id: number =0;
  public rightBottomCell: string;
  public rowCount: number =0;
  public clearEvent: PageFlags = PageFlags.None;
  public clearRange: string;
  public itemRange:string;
  public firstRowRange:string;
  public repeatRowRange:string;
  public groupingFooter1Range:string;
  public groupingFooter2Range:string;
  public groupingFooter3Range:string;    
  public groupingHeader1Range:string;
  public groupingHeader2Range:string;
  public groupingHeader3Range:string;      
  public grandTotalRange:string;

}

export enum ImageSourceFlags {
  None,
  CompanyLogo,
  CompanyStamp,
  SegmentStamp,
  SegmentSign,
  UserStamp,
  UserSign,
}

export enum PageFlags {
  None,
  FirstPage,
  LastPage,
  NotFirstPage,
  NotLastPage,
  AllPages,
}
